import "../../../../styles/Animations.css";
import { useAuthStore } from "../../../../store/store";
import { useEffect, useState } from "react";
import { Sections } from "../../data/navItem";
import { getUsername } from "helper/helper";
import toast from "react-hot-toast";
import * as api from "helper/helper";
import { parseISO, formatDistance, formatDistanceToNowStrict } from "date-fns";
import { TipoDeSolicitud } from "../../../../constants/TipoSolicitud";
import { buildName } from "helper/tools";
import locale from "date-fns/locale/es";

function NavNotice() {
  const [notificationCount, setNotificationCount] = useState(0);
  const [infoNotificaciones, setInfoNotificaciones] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const setSectionId = useAuthStore((state) => state.setSectionId);

  useEffect(() => {
    fetchData();

    const subsErrorInfoStatus = useAuthStore.subscribe(
      (state) => state.notificationCount,
      (newCount, prevCount) => {
        console.log(`-->> NEW NotiCount: ${newCount}`);

        //if (state.notificationCount !== oldState.notificationCount) {
        setNotificationCount(parseInt(newCount));

        fetchData();
        //}
      },
    );

    return () => {
      subsErrorInfoStatus();
    };

    /*  useAuthStore.subscribe((state, oldState) =>
    console.log("state", state, "oldState", oldState)

    */
  }, []);
  /*
  func updateNotificationCount(){
      const notificationCount = useAuthStore((state) => state.notificationCount);

  }
*/
  /*
  useAuthStore.subscribe(
    (state) => state.notificationCount,
    async (notificationCount) => {
      console.log("----> GOT IT");
    }
  );*/
  /*
  const unsub3 = useAuthStore.subscribe(
    (state) => state.notificationCount,
    (notificationCount, previousNotificationCount) =>
      console.log(notificationCount, previousNotificationCount)
  );
*/

  const fetchData = async () => {
    const decoded = await getUsername();

    ////
    setIsLoading(true);

    const response = await api
      .notificacionesDetalles(decoded.userId)
      .catch((error) => {
        toast.error("Error al pedir Detalles Notificaciones.");
        setIsLoading(false);
      });
    if (!response) return;

    const data = response.data;
    setNotificationCount(parseInt(data.noVistos));
    setInfoNotificaciones(data);
  };

  async function markAsVisto(item) {
    const response = await api
      .updateNotificacionDetalle(item.id, true)
      .catch((error) => {
        toast.error("Error al Marcar Como Visto.");
        setIsLoading(false);
      });
    if (!response) return;

    fetchData();
  }

  // https://github.com/date-fns/date-fns/issues/1706
  function formatDistance(token, count, options) {
    const formatDistanceLocale = {
      lessThanXSeconds: "{{count}} segundos",
      xSeconds: "{{count}} segundos",
      halfAMinute: "30 segundos",
      lessThanXMinutes: "{{count}} minutos",
      xMinutes: "{{count}} minutos",
      aboutXHours: "{{count}} horas",
      xHours: "{{count}} horas",
      xDays: "{{count}} dias",
      aboutXWeeks: "{{count}} semanas",
      xWeeks: "{{count}} semanas",
      aboutXMonths: "{{count}} meses",
      xMonths: "{{count}} meses",
      aboutXYears: "{{count}} años",
      xYears: "{{count}} años",
      overXYears: "{{count}} años",
      almostXYears: "{{count}} años",
    };

    options = options || {};

    const result = formatDistanceLocale[token].replace("{{count}}", count);

    if (options.addSuffix) {
      if (options.comparison > 0) {
        return "En " + result;
      } else {
        return "Hace " + result;
      }
    }

    return result;
  }

  // className={`${styles.textbox} ${extend.profile_img}`}
  const hasNotifications = notificationCount > 0; //.length > 0;
  const shakeAnimation = hasNotifications ? "spring-tilt-shake" : "";

  return (
    <li className="nav-item dropdown">
      <a href="#" className="nav-link nav-icon" data-bs-toggle="dropdown">
        <i className="">
          <div className={`bi bi-bell ${shakeAnimation}`}></div>
        </i>
        {hasNotifications && (
          <span className="badge bg-primary badge-number">
            {notificationCount}
          </span>
        )}
      </a>

      <ul
        className="dropdown-menu dropdown-menu-end dropdown-menu-arrow notifications"
        style={{
          height: "350px",
          overflowY: "auto",
        }}
      >
        <li className="dropdown-header">
          Tienes <span style={{ fontWeight: "bold" }}>{notificationCount}</span>{" "}
          Nuevas Notificaciones
        </li>
        <li>
          <hr className="dropdown-divider" />
        </li>

        {infoNotificaciones.notificaciones?.map((item, index) => {
          const {
            mensaje,
            tipoDeSolicitud,
            fecha,
            tipoDeAccion,
            comentarioCreador,
            tipo,
            usuarioCreador,
          } = item.notificacion;

          const creador = buildName(usuarioCreador, true);

          const tipoSolicitud = TipoDeSolicitud[tipo] ?? TipoDeSolicitud.None;
          const pastDate = parseISO(fecha + "Z");
          const currentDate = new Date(); // The current date and time

          //  const sinceTime = "d"
          /*formatDistance(pastDate, currentDate, {
            addSuffix: true,
             locale: {
      ...locale,
      formatDistance,
  },
          });*/

          const sinceTime = formatDistanceToNowStrict(pastDate, {
            addSuffix: true,
            locale: {
              ...locale,
              formatDistance,
            },
          });

          return (
            <>
              <li
                key={index}
                className="notification-item"
                onClick={() => {
                  markAsVisto(item);
                  setSectionId(Sections.Configuraciones, null);
                }}
              >
                <tipoSolicitud.image
                  style={{
                    width: "50px",
                    height: "50px",
                    marginRight: "20px",
                    stroke: "black",
                  }}
                />
                {/*<i className="bi bi-exclamation-circle text-warning"></i>*/}
                <div>
                  <h4>{tipo}</h4>
                  <p style={{ fontStyle: "italic" }}>{comentarioCreador}</p>
                  <p style={{ color: "black" }}>{mensaje}</p>
                  <p style={{ color: "gray", fontSize: "10px" }}>
                    De: {creador}
                  </p>
                  <p style={{ fontSize: "11px", fontWeight: "bold" }}>
                    {sinceTime}
                  </p>
                </div>
              </li>

              <li>
                <hr className="dropdown-divider" />
              </li>
            </>
          );
        })}
      </ul>
    </li>
  );
}

export default NavNotice;
